module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/project-design-issue/design-issue-grid/design-issue-grid.component.css
// module id = ./src/app/technical/project-design-issue/design-issue-grid/design-issue-grid.component.css
// module chunks = main